<div class="row">
  <div class="col-12">
    <span> Criteria Option: </span>
    <div class="form-group financial-criteria-options" [ngClass]="{ 'has-error': criteriaSelection.value?.length <= 0 && formDirty === true }">
      <div class="usrDefined">
        <div class="custom-control custom-radio custom-control-inline">
          <input
            (click)="formDirty = true"
            type="radio"
            id="dataAvail"
            name="dataAvail"
            [value]="dataAvailabilityOption"
            class="custom-control-input"
            (change)="criteriaChange()"
            [disabled]="readOnly"
            [(ngModel)]="filter.criteriaSelection"
            required
            #criteriaSelection="ngModel"
          />
          <label class="custom-control-label" for="dataAvail">Data availability</label>
        </div>
        <div class="custom-control custom-radio custom-control-inline">
          <input
            (click)="formDirty = true"
            type="radio"
            id="financialItems"
            name="financialItems"
            [value]="financialItemOption"
            class="custom-control-input"
            (change)="criteriaChange()"
            [disabled]="readOnly"
            [(ngModel)]="filter.criteriaSelection"
            required
            #criteriaSelection="ngModel"
          />
          <label class="custom-control-label" for="financialItems">Financial Item</label>
        </div>

        <div class="custom-control custom-radio custom-control-inline">
          <input
            (click)="formDirty = true"
            type="radio"
            id="financialCrit"
            name="financialCrit"
            [value]="financialRatioOption"
            class="custom-control-input"
            (change)="criteriaChange()"
            [disabled]="readOnly"
            [(ngModel)]="filter.criteriaSelection"
            required
            #criteriaSelection="ngModel"
          />
          <label class="custom-control-label" for="financialCrit">Financial Ratio</label>
        </div>
      </div>
      <span
        class="help-block"
        *ngIf="formDirty && criteriaSelection.value?.length <= 0 && submitClicked === true && criteriaSelection.errors.required"
      >
        Please select a criteria option
      </span>
    </div>
  </div>
</div>

<ng-container *ngIf="dataAvailabilityOption === filter.criteriaSelection || financialItemOption === filter.criteriaSelection">
  <div class="row">
    <div class="col-12">
      <div class="form-group" [ngClass]="{ 'has-error': ShowValidationMessage(vendorAccountId) || null }">
        <span class="ey-float-label">
          <select
            (click)="formDirty = true"
            class="form-control form-select"
            id="vendorAccountId"
            name="vendorAccountId"
            (ngModelChange)="updateObjectValue(vendorAccountId.value)"
            [(ngModel)]="filter.vendorAccountId"
            required
            #vendorAccountId="ngModel"
            [disabled]="readOnly"
            appLabelFloat
          >
            <option *ngIf="filter.vendorAccountId === null" [value]="undefined" disabled selected></option>
            <option *ngFor="let account of vendorAccounts" [ngValue]="account.vendorAccountId">
              {{ account.name }}
            </option>
          </select>
          <label for="vendorAccountId">Vendor Account</label>
        </span>
        <span class="help-block" *ngIf="formDirty && ShowValidationMessage(vendorAccountId) && vendorAccountId.errors.required">
          Please select a vendor account
        </span>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="financialRatioOption === filter.criteriaSelection">
  <div class="row">
    <div class="col-12">
      <div class="form-group" [ngClass]="{ 'has-error': ShowValidationMessage(ratioId) || null }">
        <span class="ey-float-label">
          <select
            class="form-control form-select"
            id="ratioId"
            name="ratioId"
            (ngModelChange)="updateObjectValue(ratioId.value)"
            [(ngModel)]="filter.ratioId"
            required
            #ratioId="ngModel"
            [disabled]="readOnly"
            appLabelFloat
          >
            <option *ngIf="!filter.ratioId" [value]="undefined" disabled selected></option>
            <option *ngFor="let rt of financialRatios" [ngValue]="rt.ratioId">
              {{ rt.name }}
            </option>
          </select>
          <label for="ratioId">Ratio</label>
        </span>
        <span class="help-block" *ngIf="ShowValidationMessage(ratioId) && ratioId.errors.required"> Please select a ratio </span>
      </div>
    </div>
  </div>
</ng-container>

<div class="row tab-view">
  <div class="col-12">
    <p-tabView id="financialtab" (onChange)="financialCriteriaTabChange()" [activeIndex]="0">
      <p-tabPanel header="Years of Study">
        <div class="row">
          <div class="col-12 text-right">{{ filter.selectedAbsoluteYr?.length || 0 }} Selected</div>
        </div>
        <div class="row">
          <div class="col-6">
            <p-table
              id="financialtbl"
              [value]="financialAbsoluteYears"
              (click)="formDirty = true"
              selectionMode="multiple"
              [(selection)]="filter.selectedAbsoluteYr"
              [scrollable]="true"
              scrollHeight="163px"
              (onRowSelect)="onRowSelectAbsoluteYears(filter.selectedAbsoluteYr)"
              (onRowUnselect)="onRowUnselectAbsoluteYears()"
              (onHeaderCheckboxToggle)="onRowSelectAbsoluteYears(filter.selectedAbsoluteYr)"
            >
              <ng-template pTemplate="header">
                <tr>
                  <th style="width: 3em" class="table-filter-row-header"><p-tableHeaderCheckbox></p-tableHeaderCheckbox>Select all Years</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
                <tr [pSelectableRow]="rowData" [pSelectableRowIndex]="rowIndex" class="table-filter-row-data">
                  <td><p-tableCheckbox [pSelectableRow]="rowData" [value]="rowData"></p-tableCheckbox>{{ rowData.label }}</td>
                </tr>
              </ng-template>
            </p-table>
          </div>
          <div class="col-6">
            <p-tree
              id="selectedAbsyr"
              (click)="formDirty = true"
              name="selectedAbsyr"
              class="selected-tree"
              [(value)]="filter.selectedAbsoluteYr"
              [(selection)]="filter.selectedAbsoluteYr"
              (onNodeUnselect)="onRowUnselectAbsoluteYears()"
              [propagateSelectionUp]="true"
              [propagateSelectionDown]="true"
              selectionMode="checkbox"
              emptyMessage=" "
            >
            </p-tree>
          </div>
        </div>
        <fieldset ngModelGroup="”financialAbsoluteYears”">
          <input type="hidden" [(ngModel)]="filter.selectedAbsoluteYr" name="selectedAbsoluteYr" #selectedAbsoluteYr="ngModel" required />
          <div class="row">
            <div class="col=12">
              <span class="help-block">
                <span *ngIf="formDirty && (!filter.selectedAbsoluteYr || filter.selectedAbsoluteYr.length < 1)"> Please select years </span>
              </span>
            </div>
          </div>
        </fieldset>
      </p-tabPanel>
    </p-tabView>
  </div>
</div>

<div class="row mt-4 pass-if-na-area" [class.mb-4]="!isBalanceSheetValueSwitchAvailable" *ngIf="dataAvailabilityOption !== filter.criteriaSelection">
  <div class="col-12">
    <label class="me-3 financial-opts">Pass If NA:</label>
    <div class="custom-control custom-radio custom-control-inline">
      <input
        type="radio"
        id="passIfNaYes"
        name="passIfNaYes"
        [value]="true"
        class="custom-control-input"
        [disabled]="readOnly || disablePassIfNa"
        [(ngModel)]="filter.isPassIfNa"
      />
      <label class="custom-control-label" for="passIfNaYes">Yes</label>
    </div>
    <div class="custom-control custom-radio custom-control-inline">
      <input
        type="radio"
        id="passIfNaNo"
        name="passIfNaNo"
        [value]="false"
        class="custom-control-input"
        [disabled]="readOnly || disablePassIfNa"
        [(ngModel)]="filter.isPassIfNa"
      />
      <label class="custom-control-label" for="passIfNaNo">No</label>
    </div>
  </div>
</div>

<div class="row balance-sheet-value-area mb-4" *ngIf="dataAvailabilityOption !== filter.criteriaSelection && isBalanceSheetValueSwitchAvailable">
  <div class="col-12">
    <label class="me-3 financial-opts">Balance Sheet Item Value:</label>
    <span class="cy-only"> CY Only </span>
    <p-inputSwitch name="balanceSheetValueSwitch" [(ngModel)]="filter.isCurrentPlusPriorYearBalanceSheetItem" [disabled]="readOnly"></p-inputSwitch>
    <span class="cy-py-avg" [ngbTooltip]="cyPyBalanceSheetTooltip" placement="top"> (CY+PY)/2 </span>
  </div>
</div>

<ng-template #cyPyBalanceSheetTooltip>
  <div class="d-flex flex-column">
    <span>CY: Current Year</span>
    <span>PY: Prior Year</span>
  </div>
</ng-template>

<div class="row" [ngClass]="{ 'mt-4': dataAvailabilityOption === filter.criteriaSelection }">
  <div class="col-6">
    <div class="form-group" [ngClass]="{ 'has-error': ShowValidationMessage(validCriteria) || null }">
      <span class="ey-float-label">
        <select
          class="form-control form-select"
          id="validCriteria"
          name="validCriteria"
          required
          #validCriteria="ngModel"
          [(ngModel)]="filter.allSelectedYear"
          [disabled]="readOnly || (dataAvailabilityOption !== filter.criteriaSelection && filter.hasAverageForSelectedYears)"
          appLabelFloat
        >
          <option *ngIf="!filter.allSelectedYear" [value]="undefined" disabled selected></option>
          <option *ngFor="let totalYear of validCriteriaTotalYears" [ngValue]="totalYear">{{ totalYear }}</option>
        </select>
        <label for="validCriteria"> Please select how the years selected should be applied </label>
      </span>
      <span class="help-block" *ngIf="ShowValidationMessage(validCriteria) && validCriteria.errors.required">
        Please select how the years selected should be applied
      </span>
      <span class="info-block" *ngIf="filter.hasAverageForSelectedYears"> All years selected will be applied for Average calculation </span>
    </div>
  </div>
  <div class="col-6">
    <ng-container *ngIf="financialRatioOption === filter.criteriaSelection">
      <p-checkbox
        name="averageForSelectedYears"
        (click)="onAverageChange()"
        [(ngModel)]="filter.hasAverageForSelectedYears"
        [disabled]="readOnly"
        binary="true"
      ></p-checkbox>
      <label>Average Ratio for selected years</label>
    </ng-container>
    <ng-container *ngIf="financialItemOption === filter.criteriaSelection">
      <p-checkbox
        name="averageForSelectedYears"
        (click)="onAverageChange()"
        [(ngModel)]="filter.hasAverageForSelectedYears"
        [disabled]="readOnly"
        binary="true"
      ></p-checkbox>
      <label>Average of Vendor Account item for selected years</label>
    </ng-container>
  </div>
</div>
<ng-container *ngIf="financialRatioOption === filter.criteriaSelection || financialItemOption === filter.criteriaSelection">
  <div class="row">
    <div class="col-6">
      <div class="form-group" [ngClass]="{ 'has-error': ShowValidationMessage(minimumValue) }">
        <span class="ey-float-label">
          <input
            class="form-control"
            id="minimumValue"
            name="minimumValue"
            pattern="{{ regularExpressionPattern.NumberWithDecimalPattern }}"
            [(ngModel)]="filter.minimumValue"
            [disabled]="readOnly"
            #minimumValue="ngModel"
            maxlength="12"
            [appRequiredIf]="!filter.maximumValue"
            appLabelFloat
          />
          <label *ngIf="financialRatioOption === filter.criteriaSelection" for="minimumValue">Minimum%</label>
          <label *ngIf="financialItemOption === filter.criteriaSelection" for="minimumValue">Minimum</label>
        </span>
        <span class="help-block" *ngIf="minimumValue.errors?.pattern"> Please Enter a valid number </span>
        <span class="help-block">
          <span *ngIf="ShowValidationMessage(minimumValue) && minimumValue.errors?.requiredIf && maximumValue.errors?.requiredIf">
            Enter a value for Minimum or Maximum or both
          </span>
        </span>
      </div>
    </div>
    <div class="col-6">
      <div class="form-group" [ngClass]="{ 'has-error': ShowValidationMessage(maximumValue) }">
        <span class="ey-float-label">
          <input
            class="form-control"
            id="maximumValue"
            name="maximumValue"
            pattern="{{ regularExpressionPattern.NumberWithDecimalPattern }}"
            [(ngModel)]="filter.maximumValue"
            [disabled]="readOnly"
            #maximumValue="ngModel"
            maxlength="12"
            [appRequiredIf]="!filter.minimumValue"
            [appMin]="filter.minimumValue"
            appLabelFloat
          />
          <label *ngIf="financialRatioOption === filter.criteriaSelection" for="maximumValue">Maximum%</label>
          <label *ngIf="financialItemOption === filter.criteriaSelection" for="maximumValue">Maximum</label>
        </span>
        <span class="help-block" *ngIf="maximumValue.errors?.pattern"> Please Enter a valid number </span>
        <span class="help-block">
          <span *ngIf="ShowValidationMessage(maximumValue) && !checkEndGreaterThanBeginning(filter.minimumValue, filter.maximumValue)">
            Maximum value must be greater than Minimum Value
          </span>
        </span>
      </div>
    </div>
    <!--<span class="help-block" *ngIf="financialItemOption === filter.criteriaSelection">
      In order to match against companies with positive and negative operating income, leave the ‘Minimum’ value field blank and set the ‘Maximum’ value to non-zero.
    </span>
    <br />-->
    <span class="help-block" *ngIf="financialItemOption === filter.criteriaSelection">
      Note: The value entered for min and max will be based on the currency unit selected during the study set up. The currency is
      <u>{{ currencyName }}</u> and currency unit is <u>{{ currencyUnitName }}</u
      >.
    </span>
  </div>
</ng-container>
